import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors } from './basicState'

export const refundableOrdersSelector = createSelector(
  pageSelectors.refund,
  (refundFragment?: WpsRuntime.atv.wps.RefundFragmentModelProps) =>
    refundFragment && refundFragment.refundableOrders
)
